<template>
    <popup-modal ref="popup">
        <h2 class="font-bold mb-4 text-xl">{{ title }}</h2>
        <div class="mb-4">{{ message }}</div>
        <div class="flex items-center justify-between">
            <button class="btn btn-md" @click.prevent="_cancel">{{ cancelButton }}</button>
            <button class="btn btn-md btn-primary" @click.prevent="_confirm">{{ okButton }}</button>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from './PopupModal.vue'

export default {
	components: {PopupModal},

	data: () => ({
		// Parameters that change depending on the type of dialogue
		title: undefined,
		message: undefined, // Main text content
		okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
		cancelButton: 'Отмена', // text for cancel button

		// Private variables
		resolvePromise: undefined,
		rejectPromise: undefined,
	}),

	methods: {
		show(opts = {}) {
			this.title = opts.title
			this.message = opts.message
			this.okButton = opts.okButton
			if (opts.cancelButton) {
				this.cancelButton = opts.cancelButton
			}
			// Once we set our config, we tell the popup modal to open
			this.$refs.popup.open()
			// Return promise so the caller can get results
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve
				this.rejectPromise = reject
			})
		},

		_confirm() {
			this.$refs.popup.close()
			this.resolvePromise(true)
		},

		_cancel() {
			this.$refs.popup.close()
			this.resolvePromise(false)
			// Or you can throw an error
			// this.rejectPromise(new Error('User cancelled the dialogue'))
		},
	},
}
</script>